"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/quote.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fquote.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteSideToJSON = exports.quoteSideFromJSON = exports.withdrawalOnChainStatusToJSON = exports.withdrawalOnChainStatusFromJSON = exports.ExecutedWithdrawalQuote = exports.WithdrawalQuote = exports.WithdrawalAmount = exports.ExecutedQuote = exports.Quote = exports.QuoteSide = exports.WithdrawalOnChainStatus = void 0;
const amount_1 = require("./amount");
const protobufPackage = 'com.step.common.proto';
var WithdrawalOnChainStatus;
(function (WithdrawalOnChainStatus) {
    WithdrawalOnChainStatus["INVALID_ON_CHAIN_STATUS"] = "INVALID_ON_CHAIN_STATUS";
    WithdrawalOnChainStatus["PENDING_ON_CHAIN_STATUS"] = "PENDING_ON_CHAIN_STATUS";
    WithdrawalOnChainStatus["CONFIRMED_ON_CHAIN_STATUS"] = "CONFIRMED_ON_CHAIN_STATUS";
    WithdrawalOnChainStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(WithdrawalOnChainStatus || (exports.WithdrawalOnChainStatus = WithdrawalOnChainStatus = {}));
var QuoteSide;
(function (QuoteSide) {
    QuoteSide["INVALID_SIDE"] = "INVALID_SIDE";
    QuoteSide["BUY"] = "BUY";
    QuoteSide["SELL"] = "SELL";
    QuoteSide["UNRECOGNIZED"] = "UNRECOGNIZED";
})(QuoteSide || (exports.QuoteSide = QuoteSide = {}));
function createBaseQuote() {
    return {
        requestId: '',
        quoteId: '',
        participantCode: '',
        amount: amount_1.Amount.fromPartial({}),
        side: QuoteSide.INVALID_SIDE,
        price: amount_1.Amount.fromPartial({}),
        total: amount_1.Amount.fromPartial({}),
        expiresAtMs: '0',
        spread: undefined,
    };
}
exports.Quote = {
    fromJSON(object) {
        const message = {
            requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : '',
            quoteId: isSet(object.quoteId) ? globalThis.String(object.quoteId) : '',
            participantCode: isSet(object.participantCode)
                ? globalThis.String(object.participantCode)
                : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            side: isSet(object.side) ? quoteSideFromJSON(object.side) : QuoteSide.INVALID_SIDE,
            price: isSet(object.price) ? amount_1.Amount.fromJSON(object.price) : amount_1.Amount.fromPartial({}),
            total: isSet(object.total) ? amount_1.Amount.fromJSON(object.total) : amount_1.Amount.fromPartial({}),
            expiresAtMs: isSet(object.expiresAtMs) ? globalThis.String(object.expiresAtMs) : '0',
        };
        if (isSet(object.spread)) {
            message.spread = amount_1.Amount.fromJSON(object.spread);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requestId !== '') {
            obj.requestId = message.requestId;
        }
        if (message.quoteId !== '') {
            obj.quoteId = message.quoteId;
        }
        if (message.participantCode !== '') {
            obj.participantCode = message.participantCode;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.side !== QuoteSide.INVALID_SIDE) {
            obj.side = quoteSideToJSON(message.side);
        }
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        if (message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.spread !== undefined) {
            obj.spread = amount_1.Amount.toJSON(message.spread);
        }
        return obj;
    },
    create(base) {
        return exports.Quote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuote();
        message.requestId = object.requestId ?? '';
        message.quoteId = object.quoteId ?? '';
        message.participantCode = object.participantCode ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.side = object.side ?? QuoteSide.INVALID_SIDE;
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : amount_1.Amount.fromPartial({});
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : amount_1.Amount.fromPartial({});
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.spread = (object.spread !== undefined && object.spread !== null)
            ? amount_1.Amount.fromPartial(object.spread)
            : undefined;
        return message;
    },
};
function createBaseExecutedQuote() {
    return { tradeId: '', requestId: '', createdAt: '0', quote: exports.Quote.fromPartial({}) };
}
exports.ExecutedQuote = {
    fromJSON(object) {
        const message = {
            tradeId: isSet(object.tradeId) ? globalThis.String(object.tradeId) : '',
            requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : '',
            createdAt: isSet(object.createdAt) ? globalThis.String(object.createdAt) : '0',
            quote: isSet(object.quote) ? exports.Quote.fromJSON(object.quote) : exports.Quote.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tradeId !== '') {
            obj.tradeId = message.tradeId;
        }
        if (message.requestId !== '') {
            obj.requestId = message.requestId;
        }
        if (message.createdAt !== '0') {
            obj.createdAt = message.createdAt;
        }
        if (message.quote !== undefined) {
            obj.quote = exports.Quote.toJSON(message.quote);
        }
        return obj;
    },
    create(base) {
        return exports.ExecutedQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExecutedQuote();
        message.tradeId = object.tradeId ?? '';
        message.requestId = object.requestId ?? '';
        message.createdAt = object.createdAt ?? '0';
        message.quote = (object.quote !== undefined && object.quote !== null)
            ? exports.Quote.fromPartial(object.quote)
            : exports.Quote.fromPartial({});
        return message;
    },
};
function createBaseWithdrawalAmount() {
    return { amount: amount_1.Amount.fromPartial({}), notional: amount_1.Amount.fromPartial({}) };
}
exports.WithdrawalAmount = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            notional: isSet(object.notional) ? amount_1.Amount.fromJSON(object.notional) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.notional !== undefined) {
            obj.notional = amount_1.Amount.toJSON(message.notional);
        }
        return obj;
    },
    create(base) {
        return exports.WithdrawalAmount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWithdrawalAmount();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.notional = (object.notional !== undefined && object.notional !== null)
            ? amount_1.Amount.fromPartial(object.notional)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseWithdrawalQuote() {
    return {
        quoteId: '',
        participantCode: '',
        withdrawalAddress: '',
        grossAmount: exports.WithdrawalAmount.fromPartial({}),
        networkFeeAmount: exports.WithdrawalAmount.fromPartial({}),
        netAmount: exports.WithdrawalAmount.fromPartial({}),
    };
}
exports.WithdrawalQuote = {
    fromJSON(object) {
        const message = {
            quoteId: isSet(object.quoteId) ? globalThis.String(object.quoteId) : '',
            participantCode: isSet(object.participantCode)
                ? globalThis.String(object.participantCode)
                : '',
            withdrawalAddress: isSet(object.withdrawalAddress)
                ? globalThis.String(object.withdrawalAddress)
                : '',
            grossAmount: isSet(object.grossAmount)
                ? exports.WithdrawalAmount.fromJSON(object.grossAmount)
                : exports.WithdrawalAmount.fromPartial({}),
            networkFeeAmount: isSet(object.networkFeeAmount)
                ? exports.WithdrawalAmount.fromJSON(object.networkFeeAmount)
                : exports.WithdrawalAmount.fromPartial({}),
            netAmount: isSet(object.netAmount)
                ? exports.WithdrawalAmount.fromJSON(object.netAmount)
                : exports.WithdrawalAmount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quoteId !== '') {
            obj.quoteId = message.quoteId;
        }
        if (message.participantCode !== '') {
            obj.participantCode = message.participantCode;
        }
        if (message.withdrawalAddress !== '') {
            obj.withdrawalAddress = message.withdrawalAddress;
        }
        if (message.grossAmount !== undefined) {
            obj.grossAmount = exports.WithdrawalAmount.toJSON(message.grossAmount);
        }
        if (message.networkFeeAmount !== undefined) {
            obj.networkFeeAmount = exports.WithdrawalAmount.toJSON(message.networkFeeAmount);
        }
        if (message.netAmount !== undefined) {
            obj.netAmount = exports.WithdrawalAmount.toJSON(message.netAmount);
        }
        return obj;
    },
    create(base) {
        return exports.WithdrawalQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWithdrawalQuote();
        message.quoteId = object.quoteId ?? '';
        message.participantCode = object.participantCode ?? '';
        message.withdrawalAddress = object.withdrawalAddress ?? '';
        message.grossAmount = (object.grossAmount !== undefined && object.grossAmount !== null)
            ? exports.WithdrawalAmount.fromPartial(object.grossAmount)
            : exports.WithdrawalAmount.fromPartial({});
        message.networkFeeAmount =
            (object.networkFeeAmount !== undefined && object.networkFeeAmount !== null)
                ? exports.WithdrawalAmount.fromPartial(object.networkFeeAmount)
                : exports.WithdrawalAmount.fromPartial({});
        message.netAmount = (object.netAmount !== undefined && object.netAmount !== null)
            ? exports.WithdrawalAmount.fromPartial(object.netAmount)
            : exports.WithdrawalAmount.fromPartial({});
        return message;
    },
};
function createBaseExecutedWithdrawalQuote() {
    return {
        quoteId: '',
        withdrawalRequestId: '',
        networkFeeQuoteId: '',
        clientWithdrawalRequestId: '',
        participantCode: '',
        withdrawalAddress: '',
        grossAmount: exports.WithdrawalAmount.fromPartial({}),
        networkFeeAmount: exports.WithdrawalAmount.fromPartial({}),
        netAmount: exports.WithdrawalAmount.fromPartial({}),
        onChainStatus: WithdrawalOnChainStatus.INVALID_ON_CHAIN_STATUS,
    };
}
exports.ExecutedWithdrawalQuote = {
    fromJSON(object) {
        const message = {
            quoteId: isSet(object.quoteId) ? globalThis.String(object.quoteId) : '',
            withdrawalRequestId: isSet(object.withdrawalRequestId)
                ? globalThis.String(object.withdrawalRequestId)
                : '',
            networkFeeQuoteId: isSet(object.networkFeeQuoteId)
                ? globalThis.String(object.networkFeeQuoteId)
                : '',
            clientWithdrawalRequestId: isSet(object.clientWithdrawalRequestId)
                ? globalThis.String(object.clientWithdrawalRequestId)
                : '',
            participantCode: isSet(object.participantCode)
                ? globalThis.String(object.participantCode)
                : '',
            withdrawalAddress: isSet(object.withdrawalAddress)
                ? globalThis.String(object.withdrawalAddress)
                : '',
            grossAmount: isSet(object.grossAmount)
                ? exports.WithdrawalAmount.fromJSON(object.grossAmount)
                : exports.WithdrawalAmount.fromPartial({}),
            networkFeeAmount: isSet(object.networkFeeAmount)
                ? exports.WithdrawalAmount.fromJSON(object.networkFeeAmount)
                : exports.WithdrawalAmount.fromPartial({}),
            netAmount: isSet(object.netAmount)
                ? exports.WithdrawalAmount.fromJSON(object.netAmount)
                : exports.WithdrawalAmount.fromPartial({}),
            onChainStatus: isSet(object.onChainStatus)
                ? withdrawalOnChainStatusFromJSON(object.onChainStatus)
                : WithdrawalOnChainStatus.INVALID_ON_CHAIN_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quoteId !== '') {
            obj.quoteId = message.quoteId;
        }
        if (message.withdrawalRequestId !== '') {
            obj.withdrawalRequestId = message.withdrawalRequestId;
        }
        if (message.networkFeeQuoteId !== '') {
            obj.networkFeeQuoteId = message.networkFeeQuoteId;
        }
        if (message.clientWithdrawalRequestId !== '') {
            obj.clientWithdrawalRequestId = message.clientWithdrawalRequestId;
        }
        if (message.participantCode !== '') {
            obj.participantCode = message.participantCode;
        }
        if (message.withdrawalAddress !== '') {
            obj.withdrawalAddress = message.withdrawalAddress;
        }
        if (message.grossAmount !== undefined) {
            obj.grossAmount = exports.WithdrawalAmount.toJSON(message.grossAmount);
        }
        if (message.networkFeeAmount !== undefined) {
            obj.networkFeeAmount = exports.WithdrawalAmount.toJSON(message.networkFeeAmount);
        }
        if (message.netAmount !== undefined) {
            obj.netAmount = exports.WithdrawalAmount.toJSON(message.netAmount);
        }
        if (message.onChainStatus !== WithdrawalOnChainStatus.INVALID_ON_CHAIN_STATUS) {
            obj.onChainStatus = withdrawalOnChainStatusToJSON(message.onChainStatus);
        }
        return obj;
    },
    create(base) {
        return exports.ExecutedWithdrawalQuote.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExecutedWithdrawalQuote();
        message.quoteId = object.quoteId ?? '';
        message.withdrawalRequestId = object.withdrawalRequestId ?? '';
        message.networkFeeQuoteId = object.networkFeeQuoteId ?? '';
        message.clientWithdrawalRequestId = object.clientWithdrawalRequestId ?? '';
        message.participantCode = object.participantCode ?? '';
        message.withdrawalAddress = object.withdrawalAddress ?? '';
        message.grossAmount = (object.grossAmount !== undefined && object.grossAmount !== null)
            ? exports.WithdrawalAmount.fromPartial(object.grossAmount)
            : exports.WithdrawalAmount.fromPartial({});
        message.networkFeeAmount =
            (object.networkFeeAmount !== undefined && object.networkFeeAmount !== null)
                ? exports.WithdrawalAmount.fromPartial(object.networkFeeAmount)
                : exports.WithdrawalAmount.fromPartial({});
        message.netAmount = (object.netAmount !== undefined && object.netAmount !== null)
            ? exports.WithdrawalAmount.fromPartial(object.netAmount)
            : exports.WithdrawalAmount.fromPartial({});
        message.onChainStatus = object.onChainStatus ?? WithdrawalOnChainStatus.INVALID_ON_CHAIN_STATUS;
        return message;
    },
};
function withdrawalOnChainStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ON_CHAIN_STATUS':
            return WithdrawalOnChainStatus.INVALID_ON_CHAIN_STATUS;
        case 1:
        case 'PENDING_ON_CHAIN_STATUS':
            return WithdrawalOnChainStatus.PENDING_ON_CHAIN_STATUS;
        case 2:
        case 'CONFIRMED_ON_CHAIN_STATUS':
            return WithdrawalOnChainStatus.CONFIRMED_ON_CHAIN_STATUS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return WithdrawalOnChainStatus.UNRECOGNIZED;
    }
}
exports.withdrawalOnChainStatusFromJSON = withdrawalOnChainStatusFromJSON;
function withdrawalOnChainStatusToJSON(object) {
    switch (object) {
        case WithdrawalOnChainStatus.INVALID_ON_CHAIN_STATUS:
            return 'INVALID_ON_CHAIN_STATUS';
        case WithdrawalOnChainStatus.PENDING_ON_CHAIN_STATUS:
            return 'PENDING_ON_CHAIN_STATUS';
        case WithdrawalOnChainStatus.CONFIRMED_ON_CHAIN_STATUS:
            return 'CONFIRMED_ON_CHAIN_STATUS';
        case WithdrawalOnChainStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.withdrawalOnChainStatusToJSON = withdrawalOnChainStatusToJSON;
function quoteSideFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SIDE':
            return QuoteSide.INVALID_SIDE;
        case 1:
        case 'BUY':
            return QuoteSide.BUY;
        case 2:
        case 'SELL':
            return QuoteSide.SELL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return QuoteSide.UNRECOGNIZED;
    }
}
exports.quoteSideFromJSON = quoteSideFromJSON;
function quoteSideToJSON(object) {
    switch (object) {
        case QuoteSide.INVALID_SIDE:
            return 'INVALID_SIDE';
        case QuoteSide.BUY:
            return 'BUY';
        case QuoteSide.SELL:
            return 'SELL';
        case QuoteSide.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.quoteSideToJSON = quoteSideToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=quote.js.map